import React from 'react'
import { AkNavigationItem } from '@atlaskit/navigation'
import {
  // createChildListMenuItem,
  WrapperLinkComponent
} from '../../utils/sidebarNavigation'
import slug from '../../constants/slug'
import Icon from '../../themes/icon'

const dashboardMenu = {
  component: (
    <AkNavigationItem
      linkComponent={WrapperLinkComponent}
      href={slug.dashboard}
      icon={Icon.dashboard}
      text="Dashboard"
    />
  )
}

const languageMenu = {
  component: (
    <AkNavigationItem
      linkComponent={WrapperLinkComponent}
      href={slug.languageLocale.base}
      icon={Icon.world}
      text="Language"
    />
  )
}

const organizationMenu = {
  component: (
    <AkNavigationItem
      linkComponent={WrapperLinkComponent}
      href={slug.organization.base}
      icon={Icon.peopleGroup}
      text="Organization"
    />
  )
}


const LicenseMenu = {
  component: (
    <AkNavigationItem
      linkComponent={WrapperLinkComponent}
      href={slug.license.base}
      icon={Icon.list}
      text="License"
    />
  )
}

const userMenu = {
  component: (
    <AkNavigationItem
      linkComponent={WrapperLinkComponent}
      href={slug.user.base}
      icon={Icon.person}
      text="User"
    />
  )
}

const qaMenu = {
  component: (
    <AkNavigationItem
      linkComponent={WrapperLinkComponent}
      href={slug.qa.base}
      icon={Icon.qa}
      text="Q&A"
    />
  )
}

export default [dashboardMenu, languageMenu, organizationMenu, LicenseMenu, userMenu, qaMenu]



// WEBPACK FOOTER //
// ./src/navigation/sidebarNavigation/mainNavigationRouter.js